// extracted by mini-css-extract-plugin
export default {"link":"_55def9ff","image":"_c4d8e458"};